import { render, staticRenderFns } from "./lichtruc.vue?vue&type=template&id=7e218df8"
import script from "./lichtruc.vue?vue&type=script&lang=js"
export * from "./lichtruc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports